// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/pricing_access.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
/**
 * Internal lane only (called by ryugu and shirohige with the end user's identity
 * forwarded exactly like shirohige's existing RfiSectionService access check).
 *
 * @generated from message mono.projectdata.v1.CheckPricingAccessRequest
 */ export class CheckPricingAccessRequest extends Message {
    static fromBinary(bytes, options) {
        return new CheckPricingAccessRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckPricingAccessRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckPricingAccessRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckPricingAccessRequest, a, b);
    }
    constructor(data){
        super(), /**
   * preferred; resolves the project
   *
   * @generated from field: string scenario_id = 1;
   */ _define_property(this, "scenarioId", ""), /**
   * used when scenario_id is empty
   *
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * "read" | "update"
   *
   * @generated from field: string action = 3;
   */ _define_property(this, "action", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CheckPricingAccessRequest, "runtime", proto3);
_define_property(CheckPricingAccessRequest, "typeName", "mono.projectdata.v1.CheckPricingAccessRequest");
_define_property(CheckPricingAccessRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CheckPricingAccessResponse
 */ export class CheckPricingAccessResponse extends Message {
    static fromBinary(bytes, options) {
        return new CheckPricingAccessResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckPricingAccessResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckPricingAccessResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckPricingAccessResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool allowed = 1;
   */ _define_property(this, "allowed", false), /**
   * "" when not found
   *
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * member | growth | pricing | denied_view_only | denied_no_authority | not_found
   *
   * @generated from field: string reason = 3;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CheckPricingAccessResponse, "runtime", proto3);
_define_property(CheckPricingAccessResponse, "typeName", "mono.projectdata.v1.CheckPricingAccessResponse");
_define_property(CheckPricingAccessResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "allowed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CheckProposalDocumentAccessRequest
 */ export class CheckProposalDocumentAccessRequest extends Message {
    static fromBinary(bytes, options) {
        return new CheckProposalDocumentAccessRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckProposalDocumentAccessRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckProposalDocumentAccessRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckProposalDocumentAccessRequest, a, b);
    }
    constructor(data){
        super(), /**
   * shirohige document id
   *
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * "read" | "update" | "delete"
   *
   * @generated from field: string action = 2;
   */ _define_property(this, "action", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CheckProposalDocumentAccessRequest, "runtime", proto3);
_define_property(CheckProposalDocumentAccessRequest, "typeName", "mono.projectdata.v1.CheckProposalDocumentAccessRequest");
_define_property(CheckProposalDocumentAccessRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CheckProposalDocumentAccessResponse
 */ export class CheckProposalDocumentAccessResponse extends Message {
    static fromBinary(bytes, options) {
        return new CheckProposalDocumentAccessResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckProposalDocumentAccessResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckProposalDocumentAccessResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckProposalDocumentAccessResponse, a, b);
    }
    constructor(data){
        super(), /**
   * false: not a proposal volume document; the caller keeps its own rule
   *
   * @generated from field: bool bound = 1;
   */ _define_property(this, "bound", false), /**
   * @generated from field: bool allowed = 2;
   */ _define_property(this, "allowed", false), /**
   * @generated from field: string project_id = 3;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string volume_document_id = 4;
   */ _define_property(this, "volumeDocumentId", ""), /**
   * bound in proposal.pricing_workbooks with unbound_at IS NULL
   *
   * @generated from field: bool is_price_volume = 5;
   */ _define_property(this, "isPriceVolume", false), /**
   * "pricing" | "proposal_content"
   *
   * @generated from field: string rule = 6;
   */ _define_property(this, "rule", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CheckProposalDocumentAccessResponse, "runtime", proto3);
_define_property(CheckProposalDocumentAccessResponse, "typeName", "mono.projectdata.v1.CheckProposalDocumentAccessResponse");
_define_property(CheckProposalDocumentAccessResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "bound",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "allowed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "volume_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "is_price_volume",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "rule",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Internal lane only (called by ryugu with the end user's identity forwarded):
 * records one project activity row for a pricing action on a proposal.
 *
 * @generated from message mono.projectdata.v1.RecordPricingActivityRequest
 */ export class RecordPricingActivityRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordPricingActivityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordPricingActivityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordPricingActivityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordPricingActivityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string summary = 2;
   */ _define_property(this, "summary", ""), /**
   * e.g. "pricing_rate"
   *
   * @generated from field: string resource_type = 3;
   */ _define_property(this, "resourceType", ""), /**
   * e.g. the rate's consumer_ref
   *
   * @generated from field: string resource_id = 4;
   */ _define_property(this, "resourceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordPricingActivityRequest, "runtime", proto3);
_define_property(RecordPricingActivityRequest, "typeName", "mono.projectdata.v1.RecordPricingActivityRequest");
_define_property(RecordPricingActivityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "resource_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "resource_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RecordPricingActivityResponse
 */ export class RecordPricingActivityResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordPricingActivityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordPricingActivityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordPricingActivityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordPricingActivityResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordPricingActivityResponse, "runtime", proto3);
_define_property(RecordPricingActivityResponse, "typeName", "mono.projectdata.v1.RecordPricingActivityResponse");
_define_property(RecordPricingActivityResponse, "fields", proto3.util.newFieldList(()=>[]));
